import React from 'react'
import './article.css'

const About = () => {
  return (
    <main style={{ 
      maxWidth: '800px', 
      margin: '0 auto', 
      padding: '40px 20px',
      textAlign: 'center'
    }}>
      <h1 className="about-title" style={{ marginBottom: '40px' }}>About Me</h1>

      <section style={{ 
        marginBottom: '40px',
        paddingBottom: '40px',
        borderBottom: '1px solid #ddd'
      }}>
        
        <p style={{ lineHeight: '1.6', color: '#333' }}>
          My name is Milo Peterson, I am currently a senior in high school. I play basketball, run track, and occasionally make a funny joke, but 
          on the side I've learned a bit of coding. While I don't particularly want a career in computer science, I've been trying to use coding to further my 
          understanding of topics I find interesting. In this case, nuclear engineering and nuclear energy are two topics I'm super interested in and excited about. 
          In order to better understand the industry and maybe teach others a thing or two along the way, I developed this blog.
        </p>
      </section>
      <section style={{ 
        marginBottom: '40px',
        paddingBottom: '40px',
        borderBottom: '1px solid #ddd'
      }}>
        <h2 style={{ marginBottom: '20px', fontSize: '24px' }}>Current Projects</h2>
        <p style={{ lineHeight: '1.6', color: '#333' }}>
          <ul>
            <li>This Blog</li>
            <li>Basketball Stat-Keeper</li>
            
          </ul>
        </p>
      </section>

      <section style={{ 
        marginBottom: '40px',
        paddingBottom: '40px',
        borderBottom: '1px solid #ddd'
      }}>
        <h2 style={{ marginBottom: '20px', fontSize: '24px' }}>Academics</h2>
        <p style={{ lineHeight: '1.6', color: '#333' }}>
          High School Senior, class of 2026(current)
        </p>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ marginBottom: '20px', fontSize: '24px' }}>Reading</h2>
        <p style={{ lineHeight: '1.6', color: '#333' }}>
          Read this: <a href="https://www.goodreads.com/book/show/30558257-unsouled">Unsouled</a>
        </p>
      </section>
    </main>
  )
}

export default About